// extracted by mini-css-extract-plugin
export default {"centerTextEditor":"TextEditor_centerTextEditor__GYuKZ","border":"TextEditor_border__+04MY"};